import React, { useRef, useState } from 'react';
import c from 'classnames';

import { RecursiveMenuTransitions } from '@uncinc/react-drupal-core';

import {
  NavigationScroll,
  useDialogHelpers,
} from '@uncinc/uncinc-react-kitchen-sink';
import type { LottieItem } from '@uncinc/uncinc-react-kitchen-sink/dist/components/Lottie/types';

import Overlay from './Overlay';
import Header from './Header';

import './style.scss';

const HeaderMenu = () => {
  const menu = useRef<HTMLDivElement>(null);
  const header = useRef<HTMLDivElement>(null);
  const lottie = useRef<LottieItem>(null);

  // We need to both use a ref and state here.
  // Without the ref, the lottie will not animate properly, because
  // of rerendering within the menu button. We need the state because
  // otherwise the useDialogHelpers hook won't redefine the isOpen boolean.
  const isOverlayOpen = useRef<boolean>(false);
  const [isDialogOpen, setDialogOpen] = useState(false);

  const toggleOverlay = (onlyClose = false) => {
    if ((!onlyClose || isOverlayOpen.current) && lottie.current) {
      lottie.current.play();
    }

    if (onlyClose) {
      isOverlayOpen.current = false;
    } else {
      isOverlayOpen.current = !isOverlayOpen.current;
    }

    setDialogOpen(isOverlayOpen.current);

    if (header.current) {
      header.current.className = isOverlayOpen.current
        ? 'HeaderMenu__Header__menu hide'
        : 'HeaderMenu__Header__menu show';
    }

    if (menu.current) {
      menu.current.className = `HeaderMenu ${isOverlayOpen.current ? 'overlay-menu-open' : ''}`;
    }
  };

  const HeaderMenuClassnames = c(
    'HeaderMenu',
    { 'overlay-menu-open': isOverlayOpen.current },
  );

  const { dialogHelpersProps } = useDialogHelpers<HTMLDivElement>({
    wrapperElement: menu,
    isOpen: isDialogOpen,
    closeFunction: toggleOverlay,
    disableClosers: false,
  });

  return (
    <NavigationScroll>
      <div
        ref={menu}
        className={HeaderMenuClassnames}
        {...dialogHelpersProps}
      >
        <RecursiveMenuTransitions.MenuTransitionProvider>
          <Header
            key="header"
            isOverlayOpen={isOverlayOpen}
            toggleOverlay={toggleOverlay}
            headerRef={header}
            lottieRef={lottie}
          />

          <Overlay toggleOverlay={toggleOverlay} />
        </RecursiveMenuTransitions.MenuTransitionProvider>
      </div>
    </NavigationScroll>
  );
};

export default HeaderMenu;
